import { render, staticRenderFns } from "./GroupEntrance.vue?vue&type=template&id=f54bef1a&scoped=true&lang=pug&"
import script from "./GroupEntrance.vue?vue&type=script&lang=js&"
export * from "./GroupEntrance.vue?vue&type=script&lang=js&"
import style0 from "./GroupEntrance.vue?vue&type=style&index=0&id=f54bef1a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54bef1a",
  null
  
)

export default component.exports